<template>
  <div class="add-appointment">
    <el-dialog :title="title" :visible.sync="value" :before-close="handleClose" :close-on-click-modal="false">
      <div class="select-date">
        <el-scrollbar style="height:100%">
          <h3 class="select-date-title">请重新选择预约日期</h3>
          <div class="select-box">
            <div :class="['select-item',{'active':index == activeIndex}]" v-for="(item,index) in contantOrderJson" @click="active(index,item)" :key="index">
              <a href="javascript:void(0)">
                <p class="item-month">{{item.month}}</p>
                <p class="item-day">{{item.day}}</p>
                <p class="item-week">{{item.week}}</p>
              </a>
            </div>
          </div>
          <h3 class="select-date-title">选择预约时间段</h3>
          <div class="date-time-box">
            <el-table :data="dataList" stripe style="width: 100%">
              <el-table-column prop="date" label="时间段">
                <template slot-scope="scope">
                  {{scope.row.beginTime}}-{{scope.row.endTime}}
                </template>
              </el-table-column>
              <el-table-column prop="canCount" label="可预约"> </el-table-column>
              <el-table-column prop="hasCount" label="已预约"> </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <span class="reserved" v-if="isDate && itemInfo.beginTime == scope.row.beginTime && itemInfo.endTime == scope.row.endTime">已预约</span>
                  <span v-else-if="scope.row.ok == 1">该时间段不可预约</span>
                  <span v-else-if="scope.row.ok == 3" class="fullReserve">预约已满</span>
                  <a href="javascript:void(1)" class="appointment" v-else @click="change(scope.row)">预约</a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as requestApi from '@/utils/appointment.url';
import { Message, MessageBox } from "element-ui";
export default {
  name: "addAppointment",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    itemInfo: {
      type: Object,
      default: {},
    },
  },
  watch: {
    value: {
      handler(val) {
        this.contantOrderJson = [];
        this.dataList = [];
        this.activeIndex = null;
        this.getAppointmentDate();
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      title: "预约改期",
      activeIndex: null,
      selectObj: {
        date: '',
        dateToken: ''
      },
      tableData: [],
      dataList: [],
      timeOrderJsonData: [],
      currentYear: '', // 当前年份
      currentMonth: '', // 当前月份
      currentDay: '', // 当前日
      today: '', // 当前日期
      contantOrderJson: [],
      weekDay: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      monthDay: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      isDate: false,
    };
  },

  methods: {
    //切换日期 
    active(index, item) {
      this.activeIndex = index;
      this.selectObj.date = item.date;
      this.isDate = this.itemInfo.date == item.date ? true : false;
      this.selectObj.dateToken = item.dateToken;
      this.getAppointmentTime(item);
    },
    // 获取预约日期
    getAppointmentDate() {
      requestApi.appointmentDate({
        bsSeq: this.itemInfo.busSeq
      }, 'get').then(res => {
        if (Number(res.status) === 200) {
          this.timeOrderJsonData = res.data;
          this.formatReserveDate();
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 获取预约时间
    getAppointmentTime(obj) {
      requestApi.appointmentTime({
        bsSeq: this.itemInfo.busSeq,
        date: obj.date,
        dateToken: obj.dateToken
      }, 'post').then(res => {
        if (Number(res.status) === 200) {
          this.dataList = res.data;
        }
      }).catch(err => {
        console.log(err);
      })
    },
    change(val) {
      let time = `${val.beginTime}-${val.endTime}`;
      MessageBox.confirm(`确认将预约改期到 ${time}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.changeAppointment(val);
      }).catch(err => {
        console.log(err)
      });
    },
    // 预约改期
    changeAppointment(val) {
      console.log(val);
      requestApi.changeAppointment({
        seq: this.itemInfo.seq,
        date: this.selectObj.date,
        timeToken: val.timeToken,
        timeSeq: val.seq
      }, 'post').then(res => {
        if (Number(res.status) === 200) {
          this.handleClose();
          this.$message.success(res.desc);
          console.log('改期成功', res.desc)
        } else {
          this.$message.error(res.desc)
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 关闭弹窗回传状态
    handleClose() {
      this.$emit("input", false);
      this.$emit("changeAppointment", false);

    },
    // 格式化时间
    formatReserveDate() {
      let _date = new Date()
      this.currentYear = _date.getFullYear()
      this.currentMonth = (_date.getMonth() + 1) > 9 ? _date.getMonth() + 1 : ('0' + (_date.getMonth() + 1))
      this.currentDay = _date.getDate()
      this.today = this.currentYear + '-' + this.currentMonth + '-' + this.currentDay
      for (var i = 0; i < this.timeOrderJsonData.length; i++) {
        var week = this.timeOrderJsonData[i].date;
        var dateToken = this.timeOrderJsonData[i].dateToken;
        var myWeek = new Date(Date.parse(week.replace(/-/g, '/')))
        var weeks, month, dateDay, attr
        weeks = this.weekDay[myWeek.getDay()]
        /* 将日期转为星期 */
        month = this.monthDay[new Date(week).getMonth()]
        /* 将日期转为月份 */
        dateDay = new Date(week).getDate()
        /* 获取多少号 */
        attr = {
          'date': week,
          'month': month,
          'week': weeks,
          'day': dateDay,
          'dateToken': dateToken
        }
        this.contantOrderJson.push(attr)
      }
      console.log('this.contantOrderJson----', this.contantOrderJson);
    },
  },
  mounted() {
    // this.formatReserveDate(); 
  }
};
</script>
<style lang="scss">
/*新增弹窗*/
.add-appointment {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .el-scrollbar {
    .el-scrollbar__bar {
      width: 8px;
      height: 100%;
      background-color: transparent !important;
      border-radius: 10px;
    }

    .el-scrollbar__thumb {
      background-color: #DDDDDD !important;
      border-radius: 10px;
    }
  }

  .el-dialog {
    width: 836px;
    height: 678px;
    color: #333333;

    .el-dialog__header {
      border-bottom: 1px solid #545454;
      margin: 0 60px;
      padding: 50px 0 10px 0;

      .el-dialog__title {
        padding: 0;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      .el-dialog__headerbtn {
        right: 60px;
        top: 60px;

        &:focus {
          outline: 1px solid $main-color;
        }
      }
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .el-table th.is-leaf {
    background: #F9F9F9;
  }

  .el-table th.el-table__cell>.cell {
    color: #45484B;
    font-weight: 500;
    line-height: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .el-table .cell{
    font-size: 16px;
  }
}
</style>
<style lang="scss" scoped>
.add-appointment {
  .select-date {
    height: 550px;
    // overflow: auto;
    // padding: 0px 20px 0 60px;
    // border: 1px solid red;
    margin: 0 auto 60px;
    width: 720px;

    .select-date-title {
      margin-top: 30px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 26px;
      padding-left: 0px;
    }

    // 选中
    .active {
      color: $main-color;
      background: #EBF4FB;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
      border: none !important;
    }

    // 预约已满
    .full {
      color: #B2B2B2;
      background: rgba(226, 226, 226, 0.7);
      border: 1px solid #E2E2E2 !important;
      position: relative;

      &::after {
        content: '预约已满';
        position: absolute;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #F13939;
        top: 60px;
        left: 33px;
        line-height: 22px;
        letter-spacing: 1px;
      }
    }

    .select-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
      padding-left: 1px;

      .select-item {
        margin-right: 17px;
        margin-top: 20px;
        width: 124px;
        height: 138px;
        border: 1px solid #BEC0C3;
        cursor: pointer;

        a {
          display: inline-block;
          width: 100%;
          height: 100%;
        }

        .item-month {
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          padding: 6px 8px;
        }

        .item-day {
          font-size: 40px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 56px;
          text-align: center;
        }

        .item-week {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          padding: 8px;
          text-align: center;
        }
      }
    }

    .date-time-box {
      width: 715px;
      border: 1px solid #DDDDDD;
      margin-top: 30px;

      .appointment {
        font-size: 16px;
        font-weight: 400;
        color: $main-color;
        cursor: pointer;
        line-height: 18px;

        a {
          display: inline;
        }
      }

      .reserved {
        font-size: 16px;
        color: #000000;
      }

      .full-appointment {
        color: #254CCA;
        cursor: no-drop;
        opacity: 0.3;
      }

    }

  }

  // .reservat-section-head{ 
  //   font-size: 18px;
  //   font-family: PingFangSC-Medium, PingFang SC;
  //   font-weight: 500;
  //   color: #333333;
  //   line-height: 26px;

  // }
  // .reservat-section-body{
  //   border: 1px solid red;
  //   width: 800px; 
  //   display: flex;
  //   align-content:space-between;
  //   align-items
  //     .reservatCard{
  //       width: 127px;
  //       height: 138px;
  //       border: 1px solid #BEC0C3; 
  //       margin-top: 22px;
  //       cursor: pointer;
  //     }
  //   }

}
</style>